<template>
  <div class="userInfo">
    <div class="userprofit clearfix">
      <div class="fl t_c">
        <img src="../assets/images/profit.png" alt="">
        <h3>{{$route.query.UserName}}</h3>
        <p>{{$route.query.nickname}}</p>
      </div>
    </div>
    <div class="contentbox">
      <div class="textbox">
        <p class="text">可提现金额：{{$route.query.withdrawal}}</p>
        <p class="text">银行卡号：{{$route.query.bank}}</p>
      </div>
      <div class="btnbox">
        <!-- <span class="icon_btn" @click="getMoney"></span> -->
        <van-button size="small" color="linear-gradient(to bottom, #3de9a9, #23cc9a)" @click="getMoney"><span class="pdl30 pdr30">立即提现</span></van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    getMoney() {
      this.$router.push({
        path: '/applyMoney',
        query: { uuid: this.$route.query.uuid }
      });
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.userInfo {
  height: 100%;
  .userprofit {
    height: 162px;
    padding-left: 34px;
    background: url(../assets/images/info_bg.jpg) no-repeat center top;
    background-size: 100% auto;
    padding-top: 30px;
    img {
      width: 55px;
      height: 55px;
      border-radius: 50%;
    }
    h3 {
      font-size: 17px;
      color: #fff;
      margin-top: 5px;
      font-weight: normal;
    }
    p {
      color: #fff;
      font-size: 17px;
      margin-top: 5px;
    }
  }
  .contentbox {
    .textbox {
      margin-top: 25px;
      .text {
        font-size: 17px;
        color: #686868;
        padding-left: 34px;
        margin-bottom: 32px;
      }
    }
    .btnbox {
      margin-top: 80px;
      text-align: center;
      .icon_btn {
        display: inline-block;
        width: 130px;
        height: 35px;
        background: url(../assets/images/btns1.png) no-repeat center center;
        background-size: 100% auto;
      }
    }
  }
}
</style>
